import { PERM, useAuth } from "@/features/auth";

const TEMPLATE_PERMISSIONS = [
  PERM.ticketTemplateInsert,
  PERM.ticketTemplateCreate,
  PERM.ticketTemplateEdit,
  PERM.ticketTemplateDelete,
];

export function useCanInsertTemplate(): boolean {
  return useAuth().hasPermission(PERM.ticketTemplateInsert);
}

export function useCanManageTemplates(): boolean {
  const { hasPermission } = useAuth();
  return TEMPLATE_PERMISSIONS.some(hasPermission);
}
